module.exports = __webpack_public_path__ + "static/img/pop_title.a27b1a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pop_title.png
// module id = Bb+z
// module chunks = 1